module.exports = __webpack_public_path__ + "static/img/ic_arrow_strong_black_down.a0f01cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_arrow_strong_black_down.png
// module id = agWh
// module chunks = 1